import AppRoutes from "./Routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SessionExpiredModal from "../shared/components/SessionExpiredModal";
import ForbiddenAccessModal from "../shared/components/ForbiddenAccessModal";
import { LicenseManager } from "ag-grid-enterprise";

function App() {

  LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-080461}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Seven_Bridges_Advisors_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{SB_Platform}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{SB_Platform}_need_to_be_licensed___{SB_Platform}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{27_June_2026}____[v3]_[01]_MTc4MjUxNDgwMDAwMA==bc65b55348d3e8e3d33837bfdbe7e4f7");

  return (
      <>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
      <SessionExpiredModal/>
      <ForbiddenAccessModal/>
      </>
  );
}

export default App;
